import React from 'react'

import { ReferralLinkCollectionItem } from '../../../../types/responses/referral-links'
import ReferralIntroducedTo from '../../ReferralIntroducedTo'

interface Props {
  referralLink: ReferralLinkCollectionItem
}

const IntroduceTo: React.FC<Props> = ({ referralLink }) => {
  const toCompanyName = referralLink.toCompany.presentationName

  // Nylas round-robin referral links
  if (referralLink.isCompanySchedulerLink) {
    return toCompanyName
  }

  // Calendly referral links
  if (referralLink.hasCalendlyScheduler) {
    return (
      <>
        {toCompanyName}
        <div className="text-sm text-muted">(Calendly)</div>
      </>
    )
  }

  // Nylas individual or multi-individual links
  return (
    <ReferralIntroducedTo
      title="List of individuals the client will be introduced to"
      users={referralLink.users}
      toCompany={referralLink.toCompany}
    />
  )
}

export default IntroduceTo
